import cx from 'classnames'
import { memo, lazy, Suspense } from 'react'

import { useResponsive } from 'hooks'

const MobileHeader = lazy(() => import('./MobileHeader'))
const DesktopHeader = lazy(() => import('./DesktopHeader'))

import './style.scss'

const Header = ({ isLandingPage = false }) => {
  const { isDesktop } = useResponsive()

  return (
    <header
      className={cx('Header', {
        'Header--landing-page': isLandingPage,
      })}
    >
      <div className="container">
        {isDesktop ? (
          <Suspense fallback={<div />}>
            <DesktopHeader isLandingPage={isLandingPage} />
          </Suspense>
        ) : (
          <Suspense fallback={<div />}>
            <MobileHeader isLandingPage={isLandingPage} />
          </Suspense>
        )}
      </div>
    </header>
  )
}

export default memo(Header)
